import Headline from '../../../components/Headline';
import { Fragment } from 'react';
import Form from './Form';

const TestingPermissions = () => {
  return (
    <Fragment>
      <Headline message='Test environment' />

      <br />

      <Form />
    </Fragment>
  );
};

export default TestingPermissions;
